

exports.__esModule = true;

var _angular = require('angular');

var _uiRouter = require('uiRouter');

var _squid = require('squid');

var _checkout = require('xo-models/src/checkout');

var _fi = require('xo-models/src/fi');

var _template = require('./template');

var _template2 = _interopRequireDefault(_template);

require('./styles');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Component.extend('$xoTopupFundingDirective', {
    tag: 'xo-topup-funding',
    template: _template2['default'],
    props: {
        token: {
            type: 'var'
        },
        success: {
            type: 'var'
        }
    },

    resolve: {
        models: function models() {
            return {
                checkoutSession: _checkout.$CheckoutSessionModel.instance(this.props.token).retrieve(),
                walletPreferences: _fi.$WalletPreferences.instance(this.props.token).retrieve()
            };
        }
    },

    actions: {
        selectFundingSource: function selectFundingSource(id) {
            if (this.models.walletPreferences.topup.fundingSource.instrument_id !== id) {
                this.models.walletPreferences.topup.fundingSource = this.models.checkoutSession.topupFundingSources.find(function (fs) {
                    return fs.instrument_id === id;
                });
                this.models.checkoutSession.action('setTopupFI', {
                    data: {
                        instrument_id: id
                    },
                    silent: true
                });
            }
            this.props.success();
        },
        addCard: function addCard() {
            _uiRouter.$state.go('.sidepageAddCard.addCardFlow.addCard');
        }
    },

    lifecycle: {
        enter: function enter() {
            var _this = this;

            this.locale = _squid.$locale;
            this.addCardCallbacks = {
                finish: function finish() {
                    if (_this.models.checkoutSession.selectedTopupFundingSource) {
                        _this.models.walletPreferences.topup.fundingSource = _this.models.checkoutSession.selectedTopupFundingSource;
                    }
                    $('#sidepageAddCard').removeClass('sidepageAddCardOpen');
                    (0, _angular.$timeout)(function () {
                        return _uiRouter.$state.go('checkout.review');
                    }, 300);
                },
                cancel: function cancel() {
                    $('#sidepageAddCard').removeClass('sidepageAddCardOpen');
                    (0, _angular.$timeout)(function () {
                        return _uiRouter.$state.go('^.^.^');
                    }, 300);
                }
            };

            this.instrumentIconId = function (name) {
                return _fi.$WalletInstrumentNameMapping.instance().getInstrumentNameNormalized(name);
            };
        }
    }
});


_angular.$timeout;

_uiRouter.$state;

_squid.$Component;

_squid.$locale;

_checkout.$CheckoutSessionModel;

_fi.$WalletPreferences;

_fi.$WalletInstrumentNameMapping;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./components/xo-wallet-components/src/topup/topup-funding/directive.js
// module id = ./components/xo-wallet-components/src/topup/topup-funding/directive.js
// module chunks = 1